import { useEffect, useRef } from 'react';

interface UseScrollIntoViewOnChangeOptions {
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
  inline?: ScrollLogicalPosition;
}

export function useScrollIntoViewOnChange<T>(
  value: T,
  options: UseScrollIntoViewOnChangeOptions = {},
) {
  const {
    behavior = 'smooth',
    block = 'start',
    inline = 'start',
  } = options;

  const sectionRef = useRef<HTMLElement>(null);
  const previousValueRef = useRef<T>(value);

  useEffect(() => {
    if (Object.is(previousValueRef.current, value)) {
      return;
    }

    previousValueRef.current = value;

    requestAnimationFrame(() => {
      sectionRef.current?.scrollIntoView({ behavior, block, inline });
    });
  }, [value, behavior, block, inline]);

  return sectionRef;
}
